import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { scrollToTop, useTimeoutEffect } from 'Modules/ui2';
import { Text, Button, Label } from 'Modules/ui2/components';

import SuccessIcon from '../Icons/registrationSuccess.sprite.svg';
import { DefaultComponentProps } from '../types';
import commonStyles from '../common.module.scss';


export const SuccessLite: FC<DefaultComponentProps> = ({ t }) => {
    useTimeoutEffect(scrollToTop, 100);
    return (
        <>
            <div className={commonStyles.resultLiteIcon}>
                <SuccessIcon />
            </div>
            <Label component='h3' weight='demibold' textSize='21-24'>
                {t('successLite.title')}
            </Label>
            <Text component='p' className={commonStyles.description} textSize='18'>
                {t('successLite.description')}
            </Text>
            <Link to='/'>
                <Button
                    variant='normal'
                    size='56'
                    className={commonStyles.button}
                >
                    {t('successLite.button')}
                </Button>
            </Link>
        </>
    );
};
